import React from "react";
import styles from "./Header.module.scss";

const Header = () => {
  return (
    <header className={styles.header}>
      <div className={styles.logo}>
        <div className={styles.companyName}>EMIfy</div>
      </div>
      <nav className={styles.nav}>
        <ul>
          <li><a href="#features">Features</a></li>
          <li><a href="#advantage">Advantage</a></li>
          <li><a href="#industries">Industries</a></li>
          <li><a href="#testimonials">Testimonials</a></li>
          <li><a href="#faqs">FAQs</a></li>
        </ul>
      </nav>
      <button className={styles.button}>Get Started</button>
    </header>
  );
};

export default Header;
